var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 3.33325H5.00064C4.08017 3.33325 3.33398 4.07944 3.33398 4.99992V6.66659C3.33398 7.58706 4.08017 8.33325 5.00064 8.33325H15.0007C15.9211 8.33325 16.6673 7.58706 16.6673 6.66659V4.99992C16.6673 4.07944 15.9211 3.33325 15.0007 3.33325Z",
    stroke: "#3AC2D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 11.6665H5.00064C4.08017 11.6665 3.33398 12.4127 3.33398 13.3332V14.9999C3.33398 15.9203 4.08017 16.6665 5.00064 16.6665H15.0007C15.9211 16.6665 16.6673 15.9203 16.6673 14.9999V13.3332C16.6673 12.4127 15.9211 11.6665 15.0007 11.6665Z",
    stroke: "#3AC2D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActive);
export default __webpack_public_path__ + "static/media/table_active.6074d876f011c920e3fa982d4a60d91d.svg";
export { ForwardRef as ReactComponent };